import React from 'react';
import './Portfolio.css';
import { Link } from 'react-router-dom';

const Portfolio = () => {
    return (
        <section className="portfolio" id="portfolio">
            <div className="container">
                <div className="port-header">
                    <div>
                        <div className="eyebrow eyebrow-w rv in">Portfolio</div>
                        <h2 className="s-title s-title-w rv in d1">Soluciones que ya<br />están funcionando</h2>
                    </div>
                    <p className="s-sub rv in d2" style={{ color: 'rgba(255,255,255,0.35)', textAlign: 'right' }}>
                        Tecnología de IA aplicada a problemas industriales reales.
                    </p>
                </div>

                <div className="pf-grid">
                    {/* Tarjeta 1 */}
                    <div className="pf-card rv in">
                        <div className="pf-num">01</div>
                        <div className="pf-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.8)" strokeWidth="1.5" strokeLinecap="round">
                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                            </svg>
                        </div>
                        <div className="pf-name">Mantenimiento predictivo</div>
                        <div className="pf-desc">
                            Detectamos fallos en maquinaria industrial antes de que ocurran, reduciendo paradas no planificadas y costos de mantenimiento con modelos de IA en tiempo real.
                        </div>
                        <div className="pf-tags">
                            <span className="pf-tag">Machine Learning</span>
                            <span className="pf-tag">IoT</span>
                            <span className="pf-tag">Industria 4.0</span>
                        </div>
                        <Link to="/portfolio/mantenimiento-predictivo" className="pf-link">
                            Ver proyecto
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M2 7h10M7 2l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </Link>
                    </div>

                    {/* Tarjeta 2 */}
                    <div className="pf-card rv in d1">
                        <div className="pf-num">02</div>
                        <div className="pf-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.8)" strokeWidth="1.5" strokeLinecap="round">
                                <circle cx="12" cy="12" r="3"/>
                                <path d="M12 2v3M12 19v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M2 12h3M19 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12"/>
                            </svg>
                        </div>
                        <div className="pf-name">Orquestador multi-agente</div>
                        <div className="pf-desc">
                            Sistema de agentes de IA que coordinan tareas complejas de forma autónoma — desde análisis de datos hasta decisiones en cadenas logísticas.
                        </div>
                        <div className="pf-tags">
                            <span className="pf-tag">Multi-agente</span>
                            <span className="pf-tag">Automatización</span>
                            <span className="pf-tag">Logística</span>
                        </div>
                        <Link to="/portfolio/orquestador-multi-agente" className="pf-link">
                            Ver proyecto
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M2 7h10M7 2l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </Link>
                    </div>

                    {/* Tarjeta 3 */}
                    <div className="pf-card rv in d2">
                        <div className="pf-num">03</div>
                        <div className="pf-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.8)" strokeWidth="1.5" strokeLinecap="round">
                                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                                <polyline points="14 2 14 8 20 8"/>
                                <line x1="16" y1="13" x2="8" y2="13"/>
                                <line x1="16" y1="17" x2="8" y2="17"/>
                            </svg>
                        </div>
                        <div className="pf-name">Cerebro documental</div>
                        <div className="pf-desc">
                            IA que lee, entiende y responde sobre cualquier documento de tu empresa — manuales, contratos, reportes — con precisión y trazabilidad total.
                        </div>
                        <div className="pf-tags">
                            <span className="pf-tag">RAG</span>
                            <span className="pf-tag">NLP</span>
                            <span className="pf-tag">Documentos</span>
                        </div>
                        <Link to="/portfolio/cerebro-documental" className="pf-link">
                            Ver proyecto
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M2 7h10M7 2l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </Link>
                    </div>

                    {/* Tarjeta 4 */}
                    <div className="pf-card rv in d3">
                        <div className="pf-num">04</div>
                        <div className="pf-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.8)" strokeWidth="1.5" strokeLinecap="round">
                                <rect x="2" y="7" width="20" height="14" rx="2"/>
                                <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/>
                                <line x1="12" y1="12" x2="12" y2="16"/>
                                <line x1="10" y1="14" x2="14" y2="14"/>
                            </svg>
                        </div>
                        <div className="pf-name">Conectividad Legacy</div>
                        <div className="pf-desc">
                            Conectamos sistemas heredados (ERP, SCADA, bases legacy) con tecnologías modernas de IA sin reemplazar la infraestructura existente.
                        </div>
                        <div className="pf-tags">
                            <span className="pf-tag">Integración</span>
                            <span className="pf-tag">ERP/SCADA</span>
                            <span className="pf-tag">Legacy</span>
                        </div>
                        <Link to="/portfolio/conectividad-legacy" className="pf-link">
                            Ver proyecto
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M2 7h10M7 2l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Portfolio;